import { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { GALLERY_IMAGES } from '@/lib/data';
import { LUXE } from '@/constants/testIds';

const GalleryPage = () => {
  const [idx, setIdx] = useState(null);

  useEffect(() => {
    if (idx === null) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setIdx(null);
      if (e.key === 'ArrowRight') setIdx((i) => (i + 1) % GALLERY_IMAGES.length);
      if (e.key === 'ArrowLeft')
        setIdx((i) => (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [idx]);

  return (
    <div className="pt-28">
      <section className="py-16 sm:py-24">
        <div className="luxe-container text-center max-w-2xl mx-auto mb-16">
          <Reveal>
            <div className="luxe-eyebrow mb-4">Portfolio</div>
            <h1 className="text-4xl sm:text-6xl text-white leading-[1.05]">
              Before & After <br />
              <span className="italic text-[#C9A24A]">Transformations.</span>
            </h1>
            <div className="gold-divider mx-auto mt-8" />
            <p className="mt-8 text-white/60">
              Every image is a real Lavish Luxe result. Hover to preview,
              click to view full size.
            </p>
          </Reveal>
        </div>

        <div className="luxe-container">
          <div className="masonry">
            {GALLERY_IMAGES.map((src, i) => (
              <Reveal key={src} delay={(i % 6) * 60}>
                <button
                  type="button"
                  data-testid={`${LUXE.galleryItem}-${i}`}
                  onClick={() => setIdx(i)}
                  className="gallery-item block w-full"
                >
                  <img src={src} alt={`Transformation ${i + 1}`} />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* LIGHTBOX */}
      {idx !== null && (
        <div
          data-testid={LUXE.galleryLightbox}
          className="fixed inset-0 z-[100] bg-[#0B0F1A]/95 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setIdx(null)}
        >
          <button
            type="button"
            data-testid={LUXE.galleryLightboxClose}
            className="absolute top-6 right-6 w-11 h-11 border border-[#C9A24A]/40 text-[#C9A24A] flex items-center justify-center hover:bg-[#C9A24A] hover:text-[#0B0F1A] transition-all"
            onClick={(e) => {
              e.stopPropagation();
              setIdx(null);
            }}
          >
            <X size={18} />
          </button>
          <button
            type="button"
            aria-label="Previous"
            className="absolute left-6 top-1/2 -translate-y-1/2 w-11 h-11 border border-[#C9A24A]/40 text-[#C9A24A] flex items-center justify-center hover:bg-[#C9A24A] hover:text-[#0B0F1A] transition-all"
            onClick={(e) => {
              e.stopPropagation();
              setIdx((i) => (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
            }}
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            aria-label="Next"
            className="absolute right-6 top-1/2 -translate-y-1/2 w-11 h-11 border border-[#C9A24A]/40 text-[#C9A24A] flex items-center justify-center hover:bg-[#C9A24A] hover:text-[#0B0F1A] transition-all"
            onClick={(e) => {
              e.stopPropagation();
              setIdx((i) => (i + 1) % GALLERY_IMAGES.length);
            }}
          >
            <ChevronRight size={18} />
          </button>
          <img
            src={GALLERY_IMAGES[idx]}
            alt="Full view"
            className="max-h-[85vh] max-w-[90vw] object-contain border border-[#C9A24A]/30"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
